import { createTheme, responsiveFontSizes } from '@mui/material/styles' // Import from '@mui/material/styles' instead of '@material-ui/core'
import { createPalette } from './palette'
import { createTypography } from './typography'

const createAppTheme = (options = {}) => {
  const {
    palette: paletteInput = {},
    typography: typographyInput = {},
    ...others
  } = options

  const palette = createPalette(paletteInput)
  const typography = createTypography(typographyInput)

  const theme = createTheme({
    components: {
      MuiTypography: {
        styleOverrides: {
          gutterBottom: {
            marginBottom: '1rem' // Use '1rem' instead of 16
          }
        }
      },
      MuiTab: {
        defaultProps: {
          iconPosition: 'start'
        },
        styleOverrides: {
          root: {
            textTransform: 'capitalize'
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none'
          }
        },
        defaultProps: {
          color: 'inherit'
        }
      },
      MuiAlert: {
        styleOverrides: {
          root: {
            maxWidth: 290,
            '& > .MuiAlert-message': {
              width: '100%'
            },
            '&.MuiAlert-standardSuccess .MuiAlert-icon': {
              color: palette.success.shade[50]
            },
            '&.MuiAlert-standardInfo .MuiAlert-icon': {
              color: palette.accent.shade[50]
            }
          },
          standardSuccess: {
            backgroundColor: palette.success.shade[0],
            color: palette.success.shade[60],
            '& .MuiAlert-icon': {
              color: palette.success.shade[50]
            },
            '& .MuiAlert-title': {
              color: palette.success.shade[80]
            },
            '& .MuiAlert-actions': {
              color: palette.success.shade[80]
            }
          },
          standardInfo: {
            backgroundColor: '#d2eafe', // @@@ secondary/5
            color: palette.accent.shade[50]
          },
          standardError: {
            backgroundColor: palette.alert.shade[0],
            color: palette.alert.shade[60],
            '& .MuiAlert-icon': {
              color: palette.alert.shade[60]
            },
            '& .MuiAlert-title': {
              color: palette.alert.shade[70]
            },
            '& .MuiAlert-actions': {
              color: palette.alert.shade[80]
            }
          },
          action: {
            alignItems: 'baseline',
            paddingTop: 4
          },
          icon: {
            fontSize: '1.125rem'
          }
        }
      },
      MuiAlertTitle: {
        styleOverrides: {
          root: {
            fontWeight: 700,
            fontSize: '0.875rem',
            textTransform: 'capitalize'
          }
        }
      }
    },
    palette,
    typography,
    ...others
  })

  // Make font-size of Typography elements responsive:
  // https://mui.com/customization/typography/#responsive-font-sizes
  return responsiveFontSizes(theme)
}

export { createAppTheme as createTheme }
